import { useContext } from "react";
import { AppContextContext } from "../../common/context";
import AnalyticsProxy from "../AnalyticsProxy";
import FallbackProxy from "../FallbackProxy";
export default () => {
  const context = useContext(AppContextContext);
  return context ? AnalyticsProxy.getInstance(context) : FallbackProxy;
};